// client/src/App.jsx
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';

// Context Providers
import MessageProvider from './context/messageContext';
import NotificationProvider from './context/notificationContext';
import UserProvider from './context/userContext';

// Layouts
import Layout from './components/common/Layout';

// Pages
import CategoryPosts from './pages/post/CategoryPosts';
import CreatePost from './pages/post/CreatePost';
import EditPost from './pages/post/EditPost';
import Feed from './pages/post/Feed';
import Home from './pages/post/Home';
import PostDetail from './pages/post/PostDetail';

import Login from './pages/auth/Login';
import Logout from './pages/auth/Logout';
import Register from './pages/auth/Register';

import AuthorPosts from './pages/user/AuthorPosts';
import Authors from './pages/user/Authors';
import Dashboard from './pages/user/Dashboard';
import Followers from './pages/user/Followers';
import Following from './pages/user/Following';
import UserProfile from './pages/user/UserProfile';

import Conversation from './pages/social/Conversation';
import Messages from './pages/social/Messages';
import NotificationsPage from './pages/social/NotificationsPage';

import ErrorPage from './pages/ErrorPage';

const App = () => {
  return (
    <Router>
      <UserProvider>
        <NotificationProvider>
          <MessageProvider>
            <Routes>
              <Route path="/" element={<Layout />}>
                {/* Home routes */}
                <Route index element={<Home />} />
                <Route path="feed" element={<Feed />} />

                {/* Post routes */}
                <Route path="posts/:id" element={<PostDetail />} />
                <Route path="create" element={<CreatePost />} />
                <Route path="posts/:id/edit" element={<EditPost />} />
                <Route path="posts/categories/:category" element={<CategoryPosts />} />

                {/* Auth routes */}
                <Route path="register" element={<Register />} />
                <Route path="login" element={<Login />} />
                <Route path="logout" element={<Logout />} />

                {/* User routes */}
                <Route path="profile/:id" element={<UserProfile />} />
                <Route path="authors" element={<Authors />} />
                <Route path="posts/users/:id" element={<AuthorPosts />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="users/:id/followers" element={<Followers />} />
                <Route path="users/:id/following" element={<Following />} />

                {/* Social routes */}
                <Route path="messages" element={<Messages />} />
                <Route path="messages/:id" element={<Conversation />} />
                <Route path="notifications" element={<NotificationsPage />} />

                {/* Catch-all error route */}
                <Route path="*" element={<ErrorPage />} />
              </Route>
            </Routes>
          </MessageProvider>
        </NotificationProvider>
      </UserProvider>
    </Router>
  );
};

export default App;